import io from 'socket.io-client'

export const ENDPOINT = process.env.REACT_APP_SOCKET_URL
// const ENDPOINT = 'http://localhost:3001';
// export const ENDPOINT = 'http://localhost:4000'
const socket = io(ENDPOINT, {
  reconnection: true, // Enable reconnection
  reconnectionAttempts: Infinity, // Attempt reconnecting infinitely
  reconnectionDelay: 1000, // Initial delay between reconnection attempts (in milliseconds)
  reconnectionDelayMax: 5000, // Maximum delay between reconnection attempts (in milliseconds)
  randomizationFactor: 0.5, // Randomization factor to vary the reconnection delay (0 to 1)
  timeout: 20000, // Connection timeout (in milliseconds)
  autoConnect: true, // Automatically connect to the server upon instantiation
  transports: ['websocket'], // Preferred transport methods (can be 'polling', 'websocket', or both)
})
export default socket

// Listen for successful connection
socket.on('connect', () => {
  console.log('Connected to server')
})

// Listen for disconnection
socket.on('disconnect', (reason) => {
  console.log('Socket disconnected:', reason)
  reloadPageWithDelay()
})

// Listen for connection errors
socket.on('connect_error', (error) => {
  console.error('Connection error:', error)
  reloadPageWithDelay()
})

// Listen for reconnection attempts
socket.on('reconnect_attempt', () => {
  console.log('Attempting to reconnect...')
})

// Listen for failed reconnection attempts
socket.on('reconnect_failed', () => {
  console.error('Reconnection failed')
  reloadPageWithDelay()
})

// Listen for reconnection success
socket.on('reconnect', (attemptNumber) => {
  console.log('Reconnected on attempt', attemptNumber)
})

// Function to reload the page after a delay
function reloadPageWithDelay() {
  setTimeout(() => {
    window.location.reload()
  }, 3000) // Reloads after 1 second
}

// Add a fallback for unhandled errors
socket.on('error', (error) => {
  console.error('Socket error:', error)
  reloadPageWithDelay()
})
